import * as React from "react"

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select"

interface DeliveryHourSelectProps {
  value: string
  onChange: (hour: string) => void
  placeholder: string
  className?: string
}

const HOURS = Array.from({ length: 24 }, (_, index) =>
  `${String(index).padStart(2, "0")}:00`
)

export const DeliveryHourSelect: React.FC<DeliveryHourSelectProps> = ({
  value,
  onChange,
  placeholder,
  className,
}) => {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={className}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {HOURS.map((hour) => (
          <SelectItem key={hour} value={hour}>
            {hour}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
